import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useCartStore = create<CartState>()(persist((set, get) => ({
    // Initial values
    cart: [],
    isOpen: false,
    modalOrder: false,

    // Actions
    addToCart: (data) => set(state => {
        const cart = [...state.cart]
        const index = cart.findIndex(item => item.sku === data.sku)
        if (index === -1) {
            cart.push({ ...data })
        } else {
            cart[index].quantity += data.quantity
        }
        return { cart }
    }),
    removeFromCart: (sku) => set(state => ({
        cart: state.cart.filter(item => item.sku !== sku)
    })),
    updateQuantity: (sku, quantity) => set(state => ({
        cart: state.cart.map(item => item.sku === sku ? { ...item, quantity } : item)
    })),
    clearCart: () => set({ cart: [] }),
    openCart: () => set({ isOpen: true }),
    closeCart: () => set({ isOpen: false }),
    closeCartOrder: () => set({ modalOrder: false }),
    checkout: (url) => {
        set({ isOpen: false, modalOrder: true})
        const urlPArams = get().cart.map(item => `sku=${item.sku}&qty=${item.quantity}&seller=1&sc=1`).join('&')
        let products:string[] = []
        get().cart.map(item => {
            for (let i = 0; i < item.quantity; i++) {
                products.push(item.name)
            }
        }).join(',')
        fetch(`${window.location.origin}/aguila/loyalty/checkout-cart`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({products: products})
        })
        setTimeout(() => {
            set({ cart: [], modalOrder: false })
            window.open(`${url}${urlPArams}`, '_blank')
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'Button',
                'event_label': 'Processing your order',
                'interaction':'true',
                'component_name': 'Modo_Carrera_TaDa_ShoppingCart',
                'element_text': 'Cerrar',
            });
        }, 2000)
    }
}), { name: 'cart-store', partialize: (state) => ({ cart: state.cart }) })) // Persist only cart

export type CartState = {
    cart: CartProduct[],
    isOpen: boolean,
    modalOrder: boolean,
    addToCart: (data: CartProduct) => void,
    removeFromCart: (id: string) => void,
    updateQuantity: (id: string, quantity: number) => void,
    clearCart: () => void,
    openCart: () => void,
    closeCart: () => void,
    checkout: (url: string) => void,
}

export type CartProduct = {
    active: 1 | 0 | boolean,
    delete: 1 | 0 | boolean,
    sku: string,
    name: string,
    descr: string,
    precio: string | number,
    precio_cantidad: string,
    img: string,
    quantity?: number,
}